import React from 'react';
import './css/TermsOfService.css';

const TermsOfService = () => {
    return (
        <div className="terms-of-service-page">
            <div className="terms-container">
                <div className="terms-header">
                    <h1>이용약관</h1>
                    <p className="terms-subtitle">부스바월드 서비스 이용약관</p>
                </div>

                <div className="terms-content">
                    <section className="terms-section">
                        <h2>제1조(목적)</h2>
                        <p>
                            이 약관은 부스바월드(이하 "회사")가 운영하는 홈페이지(www.busbarworld.com)를 통해 제공하는 서비스 이용과 관련하여 
                            회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>제2조(정의)</h2>
                        <ul>
                            <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
                            <li>"서비스"란 회사가 홈페이지를 통해 제공하는 제품 정보 열람, 견적 요청, 기술 상담 등 제반 서비스를 의미합니다.</li>
                            <li>"제품"이란 회사가 제조·가공하여 제공하는 분전반 및 차단기용 동(銅) 부스바류를 의미합니다.</li>
                            <li>"견적 요청"이란 이용자가 회사에 제품 관련 가격 또는 사양 문의를 위해 요청하는 절차를 의미합니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제3조(약관의 게시 및 개정)</h2>
                        <ul>
                            <li>회사는 본 약관을 홈페이지 초기화면에 게시하여 이용자가 쉽게 확인할 수 있도록 합니다.</li>
                            <li>회사는 관련 법령을 위배하지 않는 범위에서 약관을 개정할 수 있으며, 개정 시 홈페이지에 공지합니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제4조(서비스의 제공)</h2>
                        <p>회사는 다음과 같은 서비스를 제공합니다.</p>
                        <ul>
                            <li>제품 소개 및 기술 사양 정보 제공</li>
                            <li>견적 요청 및 회신</li>
                            <li>상담 요청 처리</li>
                            <li>기타 회사가 정하는 관련 서비스</li>
                        </ul>
                        <p>회사는 사전 고지 없이 서비스의 일부 또는 전부를 변경하거나 중단할 수 있습니다.</p>
                    </section>

                    <section className="terms-section">
                        <h2>제5조(견적 요청 및 응답)</h2>
                        <ul>
                            <li>이용자는 회사가 제공하는 양식에 따라 제품 견적을 요청할 수 있습니다.</li>
                            <li>회사는 이용자의 요청에 따라 유선, 이메일 또는 기타 방식으로 견적을 회신하며, 이 과정은 구매 계약의 청약 또는 승낙을 의미하지 않습니다.</li>
                            <li>최종 계약은 별도의 서면 계약 또는 발주 절차에 따라 확정됩니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제6조(지적재산권)</h2>
                        <ul>
                            <li>홈페이지에 게시된 모든 콘텐츠(제품 이미지, 도면, 기술 설명, 문서 등)는 회사에 저작권 및 지적재산권이 있으며, 이용자는 사전 서면 동의 없이 이를 복제, 전송, 배포, 가공할 수 없습니다.</li>
                            <li>위반 시 관련 법령에 따라 민형사상 책임이 발생할 수 있습니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제7조(면책조항)</h2>
                        <ul>
                            <li>회사는 이용자가 본 홈페이지에 게재된 정보를 이용하여 취한 행위에 대해 책임을 지지 않습니다.</li>
                            <li>회사는 제품 사양, 수량, 사용 조건에 따라 실제 제공 내용이 달라질 수 있으며, 모든 정보는 참고용입니다.</li>
                            <li>홈페이지의 운영 중단, 시스템 오류 등으로 인한 정보 손실에 대해 회사는 책임을 지지 않습니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제8조(개인정보 보호)</h2>
                        <ul>
                            <li>회사는 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하며, 관련 법령에 따라 적법하게 처리합니다.</li>
                            <li>개인정보 수집 및 이용에 대한 사항은 [개인정보처리방침]에 따릅니다.</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>제9조(관할 법원)</h2>
                        <p>본 약관과 관련된 분쟁은 회사의 본사 소재지를 관할하는 법원을 1심의 전속 관할 법원으로 합니다.</p>
                    </section>

                    <section className="terms-section">
                        <h2>부칙</h2>
                        <p>이 약관은 2025년 8월 1일부터 시행합니다.</p>
                    </section>
                </div>

                <div className="terms-footer">
                    <button onClick={() => window.close()} className="close-button">
                        창 닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService; 